"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EventsService = function EventsService($rootScope) {
  "ngInject";

  var broadcast = function broadcast(eventName, args) {
    console.log("Broadcast::", eventName, "::Args::", args);
    $rootScope.$broadcast(eventName, args);
  };

  var listen = function listen(eventName, handler) {
    return $rootScope.$on(eventName, handler);
  };

  return { broadcast: broadcast, listen: listen };
};

exports.default = EventsService;


/** WEBPACK FOOTER **
 ** ./client/app/common/services/events.service.js
 **/